<template>
  <div class="history-museum">
    <div class="item-div">
      <p class="year">역대 주장</p>
      <p class="title record">전남드래곤즈 역대 주장</p>

      <div class="former-leader">
        <div v-for="(item, index) in list" :key="index" class="grid-div">
          <img v-if="!isEmpty(item.img)" :src="imageSrc(item.img)" :alt="item.img">
          <img v-else src="@/assets/img/dragons_logo.png" alt="logo">
          <p class="num">{{item.num}}대</p>
          <p class="name">{{item.name}}</p>
          <p class="period">{{item.period}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {isEmpty} from '@/lib';

export default {
  name: 'FormerLeader',
  data() {
    return {
      list: []
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    isEmpty,
    init() {
      this.list = [
        {
          num: 1,
          period: '1995~1997',
          name: '김봉길',
          img: 'former_leader_01'
        }, {
          num: 2,
          period: '1998',
          name: '김기선',
          img: ''
        }, {
          num: 3,
          period: '1998',
          name: '유동우',
          img: 'former_leader_03'
        }, {
          num: 4,
          period: '1999',
          name: '김태영',
          img: 'former_leader_04'
        }, {
          num: 5,
          period: '2000',
          name: '노상래',
          img: 'former_leader_05'
        }, {
          num: 6,
          period: '2000~2001',
          name: '김정혁',
          img: 'former_leader_06'
        }, {
          num: 7,
        period: '2001~2002',
          name: '강철',
          img: 'former_leader_07'
        }, {
          num: 8,
          period: '2002~2003',
          name: '김도근',
          img: 'former_leader_08'
        }, {
          num: 9,
          period: '2004',
          name: '유상수',
          img: 'former_leader_09'
        }, {
          num: 10,
          period: '2005',
          name: '김현수',
          img: 'former_leader_10'
        }, {
          num: 11,
          period: '2005~2006',
          name: '김효일',
          img: 'former_leader_11'
        }, {
          num: 13,
          period: '2008',
          name: '곽태휘',
          img: 'former_leader_13'
        }, {
          num: 15,
          period: '2011~2012',
          name: '이운재',
          img: 'former_leader_15'
        }, {
          num: 16,
          period: '2013',
          name: '이승희',
          img: 'former_leader_16'
        }, {
          num: 17,
          period: '2014~2015',
          name: '방대종',
          img: 'former_leader_17'
        }, {
          num: 18,
          period: '2016~2017',
          name: '최효진',
          img: 'former_leader_18'
        }, {
          num: 19,
          period: '2018',
          name: '김영욱',
          img: 'former_leader_19'
        }, {
          num: 20,
          period: '2019',
          name: '최효진',
          img: 'former_leader_18'
        }, {
          num: 21,
          period: '2020',
          name: '김주원',
          img: 'former_leader_21'
        }, {
          num: 22,
          period: '2021',
          name: '이종호',
          img: 'former_leader_22'
        }, {
          num: 23,
          period: '2022',
          name: '김현욱',
          img: 'former_leader_23'
        }, {
          num: 24,
          period: '2023',
          name: '이후권',
          img: 'former_leader_24'
        }, {
          num: 25,
          period: '2024',
          name: '고태원',
          img: 'former_leader_25'
        }, {
          num: 26,
          period: '2025',
          name: '발디비아',
          img: 'former_leader_26'
        }
      ];

    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/leader/'+imgSrc+'.png');
    },
  }
}
</script>
